import { render } from "./UpdatePriceModal.vue?vue&type=template&id=d8869a62&scoped=true"
import script from "./UpdatePriceModal.vue?vue&type=script&lang=js"
export * from "./UpdatePriceModal.vue?vue&type=script&lang=js"

import "./UpdatePriceModal.vue?vue&type=style&index=0&id=d8869a62&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8869a62"]])

export default __exports__